import { useCallback } from 'react';
import { TGamesGridLayout, CATEGORY_VIEWS } from 'js/hooks/games/types';

import { gameTileRatio } from '../../../helpers';

export const useResizeGameTiles = ({ containerRef, categoryGameGridLayout, categoryView, isLastItem }: {
    isLastItem?: boolean;
    containerRef: React.RefObject<HTMLDivElement>;
    categoryGameGridLayout?: TGamesGridLayout;
    categoryView?: keyof typeof CATEGORY_VIEWS;
}) => {
    return useCallback(() => {
        const $gameContainer = containerRef.current;
        const { tileGap, bordersCount = 0, layout = '', columns, rows, tileSize } = categoryGameGridLayout || {};

        if (!$gameContainer) {
            return;
        }

        const itemWidth = ($gameContainer.clientWidth - Number(tileGap) * bordersCount) / (bordersCount + 1);
        const itemHeight = gameTileRatio(tileSize) * itemWidth;

        $gameContainer.style.rowGap = `${tileGap}px`;
        $gameContainer.style.columnGap = `${tileGap}px`;
        $gameContainer.style.gridTemplateAreas = layout;
        $gameContainer.style.gridTemplateRows = `repeat(${rows}, ${itemHeight}px`;
        $gameContainer.style.gridTemplateColumns = `repeat(${columns}, ${itemWidth}px`;

        if (categoryView === CATEGORY_VIEWS.grid && !isLastItem) {
            $gameContainer.style.marginBottom = `${tileGap}px`;
        }
    }, [categoryGameGridLayout, containerRef, categoryView, isLastItem]);
};
